import { memo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { TmdxSelect, Chip } from '@ds';
import { AdminFormRow, AdminFormSection } from '@ui';
import { RegionHub } from '@/api/apis/facilities';
import { renderAutocompleteItem } from '@/utils/helpers';
import { EditRegionFormType } from './types';
import { RegionManagerSelect } from './components/RegionManagerSelect';
import { ControlledTextInput } from '../components/inputs/ControlledTextInput';

const hubMapper = (hub: RegionHub) => ({
  id: hub.id,
  name: hub.name,
});

const renderHubsDropdownValue = (itemList: RegionHub[] = []) => (
  <div className="flex gap-2 flex-wrap">
    {itemList.map((hub) => (
      <Chip key={hub.id} size="sm">
        <span className="text-m-m text-base-5">{hub.name}</span>
      </Chip>
    ))}
  </div>
);

type EditRegionProps = {
  isReadOnly?: boolean;
};

export const EditRegionForm = memo(({ isReadOnly }: EditRegionProps) => {
  const { control } = useFormContext<EditRegionFormType>();

  return (
    <AdminFormSection title="Region Details">
      <AdminFormRow title="Region Name" isRequired={!isReadOnly}>
        <ControlledTextInput name="name" aria-label="Region Name" isDisabled />
      </AdminFormRow>
      <RegionManagerSelect name="regionalManagers" label="Regional Manager" isReadOnly={isReadOnly} />
      <RegionManagerSelect name="nationalManagers" label="National Manager" isReadOnly={isReadOnly} />
      <AdminFormRow title="HUBs" isRequired={!isReadOnly}>
        <Controller
          name="hubs"
          control={control}
          render={({ field: { value }, fieldState: { invalid, error } }) => (
            <TmdxSelect
              isMultiline
              selectionMode="multiple"
              placeholder="Choose an option"
              aria-label="HUBs"
              isDisabled
              isInvalid={invalid}
              errorMessage={error?.message}
              items={(value || []).map(hubMapper)}
              selectedKeys={value?.map((h) => h.id) || []}
              renderValue={() => renderHubsDropdownValue(value || [])}
            >
              {renderAutocompleteItem}
            </TmdxSelect>
          )}
        />
      </AdminFormRow>
    </AdminFormSection>
  );
});
